import type { IMetadata, UIMetadata } from '@adloid-technologies/discover-sdk';
import { assetUrl } from '../../../utils/metadata';
import { getCinematicSource } from '../../../utils/utils';

export const metadata: IMetadata = {
  models: {
    'chevrolet-captiva': {
      id: 'chevrolet-captiva',
      lightingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      postProcessingIdentifier: {
        interior: 'dome',
        exterior: 'dome',
      },
      backgroundIdentifer: 'dome',
      variants: {
        premier: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5287',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5288',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5283',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7080',
              projectId: '59',
              position: [0, 0, 0],
              maxResolution: {
                ios: '2K',
                android: '4K',
              },
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
        lt: {
          defaultSkus: [
            {
              id: 'common_exterior',
              sku: '5287',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'interior-color',
              sku: '5288',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'exterior-color',
              sku: '5283',
              projectId: '59',
              position: [0, 0, 0],
            },
            {
              id: 'dome',
              sku: '7080',
              projectId: '59',
              position: [0, 0, 0],
            },
          ],
          interiorColorIdentifier: 'interior-color',
          exteriorColorIdentifier: 'exterior-color',
        },
      },
      backgrounds: {
        g0ZA968_RpUd: {
          isDefault: true,
          sku: '7080',
          project: '59',
        },
        g0ZA968_RpUe: {
          isDefault: false,
          sku: '7079',
          project: '59',
        },
      },
      ambientLighting: {
        ambientColors: '#ff1300,#ff9f51,#aafef4,#00b6ff,#61ff87',
        ambientLightings: {},
        relevantVariants: [],
      },
      colors: {
        interior: {
          '1ahry6ef040l': {
            sku: '5288',
            project: '59',
            relevantVariants: ['premier', 'lt'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['az7g6geux1c1'],
          },
          a1e1txmplnmz: {
            sku: '5289',
            project: '59',
            relevantVariants: ['premier', 'lt'],
            notCompatibleExteriorColors: [],
            accessoriesToReload: ['az7g6geux1c1'],
          },
        },
        exterior: {
          vummvpaeqvzy: {
            sku: '5283',
            project: '59',
            relevantVariants: ['premier', 'lt'],
          },
          m9hj44coy7uz: {
            sku: '5281',
            project: '59',
            relevantVariants: ['premier', 'lt'],
          },
          b956m640eecz: {
            sku: '5284',
            project: '59',
            relevantVariants: ['premier', 'lt'],
          },
          a8m917apra8f: {
            sku: '5282',
            project: '59',
            relevantVariants: ['premier', 'lt'],
          },
          '30kmro8qpmzs': {
            sku: '5286',
            project: '59',
            relevantVariants: ['premier', 'lt'],
          },
          xxvcxp442e0j: {
            sku: '5285',
            project: '59',
            relevantVariants: ['premier', 'lt'],
          },
        },
      },
      features: {
        a26pxjlfl6a2: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Head Lamp',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_LED',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        c6cu9zuvl3h3: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Wheels',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Wheels',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        k2opkruzrj2d: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Sunroof',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Sunroof',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '8vlg0walqaux': {
          type: 'cinematic',
          view: 'exterior',
          get source() {
            return getCinematicSource(
              `${assetUrl}media/2370/AEB.webm`,
              `${assetUrl}media/2370/AEB.webm`
            );
          },
          relevantVariants: ['premier'],
        },
        k9s3znjt3lyd: {
          type: 'cinematic',
          view: 'exterior',
          get source() {
            return getCinematicSource(
              `${assetUrl}media/2370/Range.webm`,
              `${assetUrl}media/2370/Range.webm`
            );
          },
          relevantVariants: ['premier'],
        },
        aenb8uufp8eq: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Smart Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xr04kxrfutz8: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Infotainment Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Infotainment',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        g8rwatb2qokf: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Driving Modes',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Driving_Modes',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        p0am368ftxdd: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Driver Information Centre',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Driver_Information_Centre',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '5sm2vwknvwvg': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Interior',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            // {
            //   message: 'Shader_Interior',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '14ws7y9o6ph2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Seats',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            // {
            //   message: 'Shader_Seats',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        ubxysgr106ml: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Infotainment Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Infotainment',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '4wue2gfl6jkt': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['premier'],
          messages: [
            {
              message: 'Power Mirrors',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Power_Mirrors',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '3ud49gqncb2e': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Head Lamp',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_LED',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '29kx4ja7eg7r': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Wheels',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Wheels',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '1jhh1m7485kl': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Modern exterior design',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            // {
            //   message: 'Shader_Modern_exterior_design',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '8s8tx9p847si': {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Wheels',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Wheels',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        xjhzg2xjvike: {
          type: 'graphic',
          view: 'exterior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Smart Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Smart_Charging',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '5axgfh2btytx': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Infotainment Screen',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Infotainment',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        bf5spqe7qghc: {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Driver Information Centre',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Driver_Information_Centre',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '2je8obbpqtv4': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Interior',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            // {
            //   message: 'Shader_Interior',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '2kzy6a0jhsu2': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Seats',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            // {
            //   message: 'Shader_Seats',
            //   identifiers: ['common_exterior'],
            //   waitForFulfill: false,
            //   cascade: false,
            // },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '4cq85subl38y': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Camera',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Camera',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
        '2hc2o7cuwka9': {
          type: 'graphic',
          view: 'interior',
          relevantVariants: ['lt'],
          messages: [
            {
              message: 'Power Mirrors',
              identifiers: ['common_exterior'],
              waitForFulfill: true,
              cascade: false,
            },
            {
              message: 'Shader_Power_Mirrors',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          mesagesOnApply: [],
          messagesOnRemove: [],
          affectedInteractionOnApply: {},
        },
      },
      accessories: {
        '0ze58kdiphrh': {
          view: 'exterior',
          groupId: 'Sunroof',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Premier_Phev_Parts',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['premier'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        az7g6geux1c1: {
          view: 'exterior',
          groupId: 'seats',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'Black_Leatherette_Seats',
              identifiers: ['common_exterior'],
              isDefault: true,
              condition: '(5288) is (interior-color)',
              isStop: false,
            },
            {
              message: ' Beige_Leatherette_Seats',
              identifiers: ['common_exterior'],
              condition: '(5289) is (interior-color)',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['premier', 'lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
        '3ckvx6gvve791': {
          view: 'exterior',
          groupId: 'Sunroof',
          display: false,
          isDefault: true,
          applyMessages: [
            {
              message: 'LT_Phev_Parts',
              identifiers: ['exterior-color'],
              condition: '',
              isDefault: false,
              isStop: false,
            },
          ],
          cameraMessages: [],
          shaderMessages: [],
          affectedInteractionOnApply: {},
          mesagesOnApply: [],
          messagesOnRemove: [],
          dependencyAccessories: [],
          relevantVariants: ['lt'],
          notAvailableForColor: {
            interior: [],
            exterior: [],
          },
        },
      },
      packages: {},
      interactions: {
        i7vl1vjogg4n: {
          type: 'basic',
          view: ['exterior', 'interior'],
          startMessages: [
            {
              message: 'DOORS_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'variant_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DOORS_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'interior-color',
                'variant_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.0032,
                beta: 1.3201,
                radius: 5.1617,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 3.5141,
                beta: 1.4083,
                radius: 0.1,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 3.4327,
                beta: 1.3211,
                radius: 0.1,

                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier', 'lt'],
        },
        tsaymqochh74: {
          type: 'basic',
          view: ['exterior'],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'variants_parts',
                'interior-color',
                'exterior-color',
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'variants_parts',
                'interior-color',
                'exterior-color',
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 5.1465,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 1.577,
                beta: 1.388,
                radius: 0.1,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 1.56,
                beta: 1.583,
                radius: 0.1,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier', 'lt'],
        },
        u18c8goidt2c: {
          type: 'basic-light',
          view: ['exterior'],
          startMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'HEADLIGHT_GLOW',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.4729,
                radius: 4.3405,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier', 'lt'],
        },
        qpa1nen87vah: {
          type: 'basic-light',
          view: ['exterior'],
          startMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'DRL_GLOW',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 1.573,
                beta: 1.473,
                radius: 4.7,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier', 'lt'],
        },
        etgu38d7vg8q: {
          type: 'basic-light',
          view: ['exterior'],
          startMessages: [
            {
              message: 'EXT_TAILLIGHT_GLOW',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'EXT_TAILLIGHT_GLOW',
              identifiers: ['common_exterior'],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7054,
                beta: 1.4258,
                radius: 3.9547,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {},
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier', 'lt'],
        },
        '1dzdmvhl8vp23': {
          type: 'basic',
          view: ['exterior'],
          startMessages: [
            {
              message: 'SUNROOF_SHADE_OPEN',
              identifiers: [
                'variants_parts',
                'interior-color',
                'exterior-color',
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          reverseMessages: [
            {
              message: 'SUNROOF_SHADE_CLOSE',
              identifiers: [
                'variants_parts',
                'interior-color',
                'exterior-color',
                'common_exterior',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.7049,
                beta: 0.115,
                radius: 3.2,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier'],
        },
        o1jxfnah7tvf: {
          type: 'basic',
          view: ['exterior'],
          dependsOn: ['tsaymqochh74'],
          reverseMessages: [
            {
              message: 'TAILGATE_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'SEAT_FOLD_RL_OPEN',

              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'SEAT_FOLD_RR_OPEN',

              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          startMessages: [
            {
              message: 'TAILGATE_OPEN',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'SEAT_FOLD_RR_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
            {
              message: 'SEAT_FOLD_RL_CLOSE',
              identifiers: [
                'exterior-color',
                'common_exterior',
                'common_interior',
                'interior-color',
                'variants_parts',
              ],
              waitForFulfill: false,
              cascade: false,
            },
          ],
          camera: {
            exteriorCamera: {
              type: 'exterior',
              messages: {
                alpha: 4.71,
                beta: 1.3951,
                radius: 4.5,
                isBlend: true,
                blendInSeconds: 1.5,
              },
            },
            interiorCamera: {
              type: 'interior',
              messages: {
                alpha: 4.7145,
                beta: 3.1212,
                radius: 0.1,
              },
            },
            interiorCamera_1: {
              type: 'interior',
              messages: {
                alpha: 4.7222,
                beta: 1.8799,
                radius: 0.1,
              },
            },
            interiorCamera_2: {
              type: 'interior',
              messages: {},
            },
          },
          relevantVariants: ['premier', 'lt'],
        },
      },
      hotspots: {
        exteriorCamera: {
          type: 'exterior',
          messages: {
            fov: 0.8,
            alpha: 2.02,
            beta: 1.47,
            radius: 5.7,
            upperRadiusLimit: 6.7,
            lowerRadiusLimit: 3.2,
            lowerBetaLimit: 0.1,
            upperBetaLimit: 1.6,
            lowerAlphaLimit: null,
            upperAlphaLimit: null,
            target: {
              x: 0,
              y: 0.65,
              z: 0,
            },
            isFovZoomModeOn: false,
          },
        },
        interiorCamera: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA',
            identifiers: ['common_exterior'],
          },
        },
        interiorCamera_1: {
          type: 'interior',
          messages: {
            message: 'INT_DEFAULT_CAMERA_2',
            identifiers: ['common_exterior'],
          },
        },
        interiorCamera_2: {
          type: 'interior',
          messages: {},
        },
      },
      usdzPathWithVariable: '',
    },
  },
};

// export const uiMetadata: UIMetadata = {
//   models: {
//     'chevrolet-captiva': {
//       variants: {
//         premier: {
//           name: {
//             en: 'Premier',
//             ar: 'Premier',
//           },
//           image: 'captiva_premier',
//           price: {
//             UAE: 109900,
//             KSA: 109900,
//             KW: 7640,
//             default: 109900,
//           },
//           index: 0,
//           isDefault: true,
//           ar: {
//             enable: false,
//             redirection: false,
//           },
//         },
//         lt: {
//           name: {
//             en: 'LT',
//             ar: 'LT',
//           },
//           image: 'captiva_premier_lt',
//           price: {
//             UAE: 104900,
//             KSA: 104900,
//             KW: 7240,
//             default: 104900,
//           },
//           index: 1,
//           isDefault: false,
//           ar: {
//             enable: false,
//             redirection: false,
//           },
//         },
//       },
//       backgrounds: {
//         g0ZA968_RpUd: {
//           title: {
//             en: 'City Landscape 1',
//             ar: 'غروب الشمس على الشاطئ',
//           },
//           src: 'HDRI/hdri_1.png',
//           isDefault: true,
//         },
//         g0ZA968_RpUe: {
//           title: {
//             en: 'City Landscape 2',
//             ar: 'غروب الشمس على الشاطئ',
//           },
//           src: 'HDRI/hdri_2.png',
//           isDefault: false,
//         },
//       },
//       ambientLighting: {},
//       colors: {
//         interior: {
//           '1ahry6ef040l': {
//             label: {
//               en: 'Black Leatherette',
//               ar: 'جلدي أسود',
//             },
//             image: 'captiva_black_leatherette',
//             usdz: 'interior_red',
//             price: {
//               UAE: 0,
//               KSA: 0,
//               KW: 0,
//               default: 0,
//             },
//             accessoriesToReload: ['az7g6geux1c1'],
//             index: 0,
//             type: 'interior',
//             cardType: 'cart',
//             cartImage: 'int_colors/Black_Leatherette.jpg',
//             hasQuantity: false,
//           },
//           a1e1txmplnmz: {
//             label: {
//               en: 'Beige Leatherette',
//               ar: 'جلد صناعي بيج',
//             },
//             image: 'captiva_beige_leatherette',
//             usdz: 'interior_red',
//             price: {
//               UAE: 0,
//               KSA: 0,
//               KW: 0,
//               default: 0,
//             },
//             accessoriesToReload: ['az7g6geux1c1'],
//             index: 1,
//             type: 'interior',
//             cardType: 'cart',
//             cartImage: 'int_colors/Beige_Leatherette.jpg',
//             hasQuantity: false,
//           },
//         },
//         exterior: {
//           vummvpaeqvzy: {
//             label: {
//               en: 'Khaki Green',
//               ar: 'الكاكي الأخضر',
//             },
//             image: 'captiva_khaki_green',
//             usdz: 'red_black',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 0,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Khaki_Green.png',
//             hasQuantity: false,
//           },
//           m9hj44coy7uz: {
//             label: {
//               en: 'Galaxy White',
//               ar: 'جالاكسي وايت',
//             },
//             image: 'captiva_galaxy_white',
//             usdz: 'black',
//             price: {
//               UAE: 0,
//               KSA: 0,
//               KW: 0,
//               default: 0,
//             },
//             index: 1,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Galaxy_White.png',
//             hasQuantity: false,
//           },
//           b956m640eecz: {
//             label: {
//               en: 'Laser Grey',
//               ar: 'رمادي ليزر',
//             },
//             image: 'captiva_laser_grey',
//             usdz: 'silver',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 2,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Laser_Grey.png',
//             hasQuantity: false,
//           },
//           a8m917apra8f: {
//             label: {
//               en: 'Shadow Golden',
//               ar: 'الظل الذهبي',
//             },
//             image: 'captiva_shadow_golden',
//             usdz: 'red',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 3,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Shadow_Golden.png',
//             hasQuantity: false,
//           },
//           '30kmro8qpmzs': {
//             label: {
//               en: 'Red Metallic',
//               ar: 'أحمر معدني',
//             },
//             image: 'captiva_red_metallic',
//             usdz: 'white',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 4,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Red_Metalic.png',
//             hasQuantity: false,
//           },
//           xxvcxp442e0j: {
//             label: {
//               en: 'Dawn Blue',
//               ar: 'الفجر الأزرق',
//             },
//             image: 'captiva_dawn_blue',
//             usdz: 'blue',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 5,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Dawn_Blue.png',
//             hasQuantity: false,
//           },
//           '37xytt0490j8': {
//             label: {
//               en: 'Khaki Green',
//               ar: 'الكاكي الأخضر',
//             },
//             image: 'captiva_khaki_green',
//             usdz: 'red_black',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 0,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Khaki_Green.png',
//             hasQuantity: false,
//           },
//           '2fa06p9t7v8f': {
//             label: {
//               en: 'Galaxy White',
//               ar: 'جالاكسي وايت',
//             },
//             image: 'captiva_galaxy_white',
//             usdz: 'black',
//             price: {
//               UAE: 0,
//               KSA: 0,
//               KW: 0,
//               default: 0,
//             },
//             index: 1,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Galaxy_White.png',
//             hasQuantity: false,
//           },
//           '69xux2hlscm1': {
//             label: {
//               en: 'Laser Grey',
//               ar: 'رمادي ليزر',
//             },
//             image: 'captiva_laser_grey',
//             usdz: 'silver',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 2,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Laser_Grey.png',
//             hasQuantity: false,
//           },
//           '5xzh26yrdinw': {
//             label: {
//               en: 'Shadow Golden',
//               ar: 'الظل الذهبي',
//             },
//             image: 'captiva_shadow_golden',
//             usdz: 'red',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 3,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Shadow_Golden.png',
//             hasQuantity: false,
//           },
//           '2fbmj48vpgsi': {
//             label: {
//               en: 'Red Metallic',
//               ar: 'أحمر معدني',
//             },
//             image: 'captiva_red_metallic',
//             usdz: 'white',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 4,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Red_Metalic.png',
//             hasQuantity: false,
//           },
//           '10xy9i682nxc': {
//             label: {
//               en: 'Dawn Blue',
//               ar: 'الفجر الأزرق',
//             },
//             image: 'captiva_dawn_blue',
//             usdz: 'blue',
//             price: {
//               UAE: 1098,
//               KSA: 1122,
//               KW: 91,
//               default: 1098,
//             },
//             index: 5,
//             type: 'exterior',
//             cardType: 'cart',
//             cartImage: 'ext_colors/Dawn_Blue.png',
//             hasQuantity: false,
//           },
//         },
//       },
//       features: {
//         a26pxjlfl6a2: {
//           title: {
//             en: 'Sleek LED Lights',
//             ar: 'أضواء LED أنيقة',
//           },
//           image: 'captiva_light',

//           desc: {
//             en: 'LED Headlamps and DRL',
//             ar: 'مصابيح أمامية LED ومصابيح نهارية',
//           },
//           type: 'exterior',
//         },
//         c6cu9zuvl3h3: {
//           title: {
//             en: 'Premium Alloy Wheels',
//             ar: 'عجلات معدنية فاخرة',
//           },
//           image: 'captiva_wheels',

//           desc: {
//             en: '18" Alloy Wheels',
//             ar: 'عجلات معدنية مقاس 18 بوصة',
//           },
//           type: 'exterior',
//         },
//         k2opkruzrj2d: {
//           title: {
//             en: 'Panoramic Sunroof',
//             ar: 'فتحة سقف بانورامية',
//           },
//           image: 'captiva_sunroof',

//           desc: {
//             en: 'Panoramic Sunroof with Smart Adjustment',
//             ar: 'تعديل ذكي لفتحة السقف البانورامية',
//           },
//           type: 'exterior',
//         },
//         '8vlg0walqaux': {
//           title: {
//             en: 'Advanced Safety Features',
//             ar: 'ميزات السلامة المتقدمة',
//           },
//           image: 'captiva_range',

//           desc: {
//             en: 'Advanced safety features with intelligent driving assistance, 360 camera, forward collision alert, lane departure warning, centering and assist and much more',
//             ar: 'ميزات أمان متقدمة مع مساعدة القيادة الذكية، وكاميرا 360، وتنبيه الاصطدام الأمامي، وتحذير مغادرة المسار، والتركيز والمساعدة وغير ذلك الكثير',
//           },
//           type: 'exterior',
//         },
//         k9s3znjt3lyd: {
//           title: {
//             en: 'Range',
//             ar: 'يتراوح',
//           },
//           image: 'captiva_range',

//           desc: {
//             en: 'Impressive Range: 1000 KM + PHEV to go confidently',
//             ar: 'مدى مثير للإعجاب: 1000 كم + سيارة هجينة قابلة للشحن للانطلاق بثقة',
//           },
//           type: 'exterior',
//         },
//         aenb8uufp8eq: {
//           title: {
//             en: 'Smart charging',
//             ar: 'الشحن الذكي',
//           },
//           image: 'captiva_smart_charging',

//           desc: {
//             en: 'Engine 1.5L with electric motor and 20.5KW battery – combined range 1000KM. Enjoy every trip without limits and charge energy at your convenience, whether it is electricity or fuel.',
//             ar: 'محرك سعة ١.٥ لتر مع محرك كهربائي وبطارية ٢٠.٥ كيلوواط - مدى إجمالي ١٠٠٠ كيلومتر. استمتع بكل رحلة بلا حدود، واشحن طاقتك براحتك، سواءً بالكهرباء أو بالوقود.',
//           },
//           type: 'exterior',
//         },
//         xr04kxrfutz8: {
//           title: {
//             en: '15.6" Touchscreen',
//             ar: 'شاشة تعمل باللمس مقاس 15.6 بوصة',
//           },
//           image: 'captiva_infotainment_screen',

//           desc: {
//             en: '15.6" Infotainment Screen with apple carplay & android auto',
//             ar: 'شاشة معلومات وترفيه مقاس 15.6 بوصة مع Apple CarPlay وAndroid Auto',
//           },
//           type: 'interior',
//         },
//         g8rwatb2qokf: {
//           title: {
//             en: 'Driving Modes',
//             ar: 'أوضاع القيادة',
//           },
//           image: 'captiva_driving_modes',

//           desc: {
//             en: 'Car comes with EV, EV Max and Hybrid driving modes',
//             ar: 'تأتي السيارة مع أوضاع القيادة EV و EV Max و Hybrid',
//           },
//           type: 'interior',
//         },
//         p0am368ftxdd: {
//           title: {
//             en: 'Driver Information Centre',
//             ar: 'مركز معلومات السائق',
//           },
//           image: 'captiva_driver_info',

//           desc: {
//             en: '8.8” Driver Information Centre',
//             ar: 'مركز معلومات السائق مقاس 8.8 بوصة',
//           },
//           type: 'interior',
//         },
//         '5sm2vwknvwvg': {
//           title: {
//             en: 'Refined Spacious Interior',
//             ar: 'تصميم داخلي واسع ومُحسّن',
//           },
//           image: 'captiva_interior',

//           desc: {
//             en: 'Spacious 5 seats with foldable seats, ample storage (532 L cargo and 1690 L with folded seats) and added comfort',
//             ar: '5 مقاعد واسعة مع مقاعد قابلة للطي، ومساحة تخزين واسعة (532 لترًا من الأمتعة و1690 لترًا مع مقاعد قابلة للطي) وراحة إضافية',
//           },
//           type: 'interior',
//         },
//         '14ws7y9o6ph2': {
//           title: {
//             en: 'Leatherette Seats',
//             ar: 'مقاعد جلدية',
//           },
//           image: 'captiva_int_seats',

//           desc: {
//             en: 'Refined Interior with comfortable leatherette seats and wooden finish dashboard',
//             ar: 'تصميم داخلي أنيق مع مقاعد مريحة من الجلد الصناعي ولوحة قيادة خشبية',
//           },
//           type: 'interior',
//         },
//         ubxysgr106ml: {
//           title: {
//             en: '360 Degree Camera',
//             ar: 'كاميرا 360 درجة',
//           },
//           image: 'captiva_camera',

//           desc: {
//             en: '360 degree camera to enhance visibility for parking and driving in tight spaces. It helps with Intelligent Driving Assist, Lane Departure Warning and Assist.',
//             ar: 'كاميرا بزاوية 360 درجة لتحسين الرؤية عند ركن السيارة والقيادة في الأماكن الضيقة. تدعم نظام مساعدة القيادة الذكي، ونظام تحذير مغادرة المسار، ونظام المساعدة.',
//           },
//           type: 'interior',
//         },
//         '4wue2gfl6jkt': {
//           title: {
//             en: 'Power Folding Mirrors',
//             ar: 'مرايا قابلة للطي كهربائياً',
//           },
//           image: 'features/Power_Mirrors.jpg',

//           desc: {
//             en: 'Power Folding Mirrors',
//             ar: 'مرايا قابلة للطي كهربائياً',
//           },
//           type: 'interior',
//         },
//         '3ud49gqncb2e': {
//           title: {
//             en: 'Sleek LED Lights',
//             ar: 'أضواء LED أنيقة',
//           },
//           image: 'captiva_light',

//           desc: {
//             en: 'LED Headlamps and DRL',
//             ar: 'مصابيح أمامية LED ومصابيح نهارية',
//           },
//           type: 'exterior',
//         },
//         '29kx4ja7eg7r': {
//           title: {
//             en: 'Premium Alloy Wheels',
//             ar: 'عجلات معدنية فاخرة',
//           },
//           image: 'captiva_wheels',

//           desc: {
//             en: '18" Alloy Wheels',
//             ar: 'عجلات معدنية مقاس 18 بوصة',
//           },
//           type: 'exterior',
//         },
//         '1jhh1m7485kl': {
//           title: {
//             en: 'Elevated Finishing',
//             ar: 'تصميم جسم مرتفع',
//           },
//           image: 'captiva_modern_exterior',

//           desc: {
//             en: 'Modern exterior design',
//             ar: 'التصميم الخارجي الحديث',
//           },
//           type: 'exterior',
//         },
//         '8s8tx9p847si': {
//           title: {
//             en: 'Range',
//             ar: 'يتراوح',
//           },
//           image: 'captiva_range',

//           desc: {
//             en: 'Impressive Range: 1000 KM + PHEV to go confidently',
//             ar: 'مدى مثير للإعجاب: 1000 كم + سيارة هجينة قابلة للشحن للانطلاق بثقة',
//           },
//           type: 'exterior',
//         },
//         xjhzg2xjvike: {
//           title: {
//             en: 'Smart charging',
//             ar: 'الشحن الذكي',
//           },
//           image: 'captiva_smart_charging',

//           desc: {
//             en: 'Engine 1.5L with electric motor and 20.5KW battery – combined range 1000KM. Enjoy every trip without limits and charge energy at your convenience, whether it is electricity or fuel.',
//             ar: 'محرك سعة ١.٥ لتر مع محرك كهربائي وبطارية ٢٠.٥ كيلوواط - مدى إجمالي ١٠٠٠ كيلومتر. استمتع بكل رحلة بلا حدود، واشحن طاقتك براحتك، سواءً بالكهرباء أو بالوقود.',
//           },
//           type: 'exterior',
//         },
//         '5axgfh2btytx': {
//           title: {
//             en: '10.1" Touchscreen',
//             ar: 'شاشة تعمل باللمس مقاس 10.1 بوصة',
//           },
//           image: 'captiva_infotainment_screen',

//           desc: {
//             en: '10.1" Infotainment Screen with apple carplay & android auto',
//             ar: 'شاشة معلومات وترفيه مقاس 10.1 بوصة مع Apple CarPlay وAndroid Auto',
//           },
//           type: 'interior',
//         },
//         bf5spqe7qghc: {
//           title: {
//             en: 'Driver Information Centre',
//             ar: 'مركز معلومات السائق',
//           },
//           image: 'captiva_driver_info',

//           desc: {
//             en: '8.8” Driver Information Centre',
//             ar: 'مركز معلومات السائق مقاس 8.8 بوصة',
//           },
//           type: 'interior',
//         },
//         '2je8obbpqtv4': {
//           title: {
//             en: 'Refined Spacious Interior',
//             ar: 'تصميم داخلي واسع ومُحسّن',
//           },
//           image: 'captiva_interior',

//           desc: {
//             en: 'Spacious 5 seats with foldable seats, ample storage (532 L cargo and 1690 L with folded seats) and added comfort',
//             ar: '5 مقاعد واسعة مع مقاعد قابلة للطي، ومساحة تخزين واسعة (532 لترًا من الأمتعة و1690 لترًا مع مقاعد قابلة للطي) وراحة إضافية',
//           },
//           type: 'interior',
//         },
//         '2kzy6a0jhsu2': {
//           title: {
//             en: 'Leatherette Seats',
//             ar: 'مقاعد جلدية',
//           },
//           image: 'captiva_interior',

//           desc: {
//             en: 'Refined Interior with comfortable leatherette seats and wooden finish dashboard',
//             ar: 'تصميم داخلي أنيق مع مقاعد مريحة من الجلد الصناعي ولوحة قيادة خشبية',
//           },
//           type: 'interior',
//         },
//         '4cq85subl38y': {
//           title: {
//             en: '360 Degree Camera',
//             ar: 'كاميرا 360 درجة',
//           },
//           image: 'captiva_camera',

//           desc: {
//             en: '360 degree camera to enhance visibility for parking and driving in tight spaces. It helps with Intelligent Driving Assist, Lane Departure Warning and Assist.',
//             ar: 'كاميرا بزاوية 360 درجة لتحسين الرؤية عند ركن السيارة والقيادة في الأماكن الضيقة. تدعم نظام مساعدة القيادة الذكي، ونظام تحذير مغادرة المسار، ونظام المساعدة.',
//           },
//           type: 'interior',
//         },
//         '2hc2o7cuwka9': {
//           title: {
//             en: 'Power Folding Mirrors',
//             ar: 'مرايا قابلة للطي كهربائياً',
//           },
//           image: 'features/Power_Mirrors.jpg',

//           desc: {
//             en: 'Power Folding Mirrors',
//             ar: 'مرايا قابلة للطي كهربائياً',
//           },
//           type: 'interior',
//         },
//       },
//       accessories: {
//         '0ze58kdiphrh': {
//           title: {
//             en: 'Sunroof',
//             ar: 'فتحة السقف',
//           },
//           image: 'with_sunroof',
//           category: {
//             en: 'Roof',
//             ar: 'سَطح',
//           },
//           price: {
//             UAE: 5285,
//             KSA: 4503,
//             KW: 367,
//             default: 5285,
//           },
//           cardType: 'cart',
//         },
//         az7g6geux1c1: {
//           title: {
//             en: 'Seat',
//             ar: 'فتحة السقف',
//           },
//           image: 'with_sunroof',
//           category: {
//             en: 'Roof',
//             ar: 'سَطح',
//           },
//           price: {
//             UAE: 5285,
//             KSA: 4503,
//             KW: 367,
//             default: 5285,
//           },
//           cardType: 'cart',
//         },
//       },
//       packages: {},
//       interactions: {
//         i7vl1vjogg4n: {
//           title: {
//             en: 'Doors',
//             ar: 'الأبواب',
//           },
//           type: 'interaction',
//         },
//         tsaymqochh74: {
//           title: {
//             en: 'Boot',
//             ar: 'صندوق المركبة',
//           },
//           type: 'interaction',
//         },
//         u18c8goidt2c: {
//           title: {
//             en: 'Headlight',
//             ar: 'ضوء السقف',
//           },
//           type: 'interaction',
//         },
//         qpa1nen87vah: {
//           title: {
//             en: 'DRL',
//             ar: 'DRL',
//           },
//           type: 'interaction',
//         },
//         etgu38d7vg8q: {
//           title: {
//             en: 'Taillight',
//             ar: 'الضوء الخلفي',
//           },
//           type: 'interaction',
//         },
//         '1dzdmvhl8vp23': {
//           title: {
//             en: 'Sunroof',
//             ar: 'الضوء الخلفي',
//           },
//           type: 'interaction',
//         },
//         o1jxfnah7tvf: {
//           title: {
//             en: '2nd Row Folding',
//             ar: 'الصف الثاني قابل للطي',
//           },
//           type: 'interaction',
//         },
//         f9s7b4hdeiz7: {
//           title: {
//             en: 'Doors',
//             ar: 'الأبواب',
//           },
//           type: 'interaction',
//         },
//         '1nad76ictp6j': {
//           title: {
//             en: 'Boot',
//             ar: 'صندوق المركبة',
//           },
//           type: 'interaction',
//         },
//         '3cqy8q29b96c': {
//           title: {
//             en: 'Headlight',
//             ar: 'ضوء السقف',
//           },
//           type: 'interaction',
//         },
//         '2ca59s6yd3u9': {
//           title: {
//             en: 'DRL',
//             ar: 'DRL',
//           },
//           type: 'interaction',
//         },
//         '1dzdmvhl8vp3': {
//           title: {
//             en: 'Taillight',
//             ar: 'الضوء الخلفي',
//           },
//           type: 'interaction',
//         },
//       },
//       hotspots: {
//         exteriorCamera: {
//           type: 'exterior',
//           messages: {
//             fov: 0.8,
//             alpha: 2.02,
//             beta: 1.47,
//             radius: 5.7,
//             upperRadiusLimit: 6.7,
//             lowerRadiusLimit: 3.2,
//             lowerBetaLimit: 0.1,
//             upperBetaLimit: 1.6,
//             lowerAlphaLimit: null,
//             upperAlphaLimit: null,
//             target: {
//               x: 0,
//               y: 0.65,
//               z: 0,
//             },
//             isFovZoomModeOn: false,
//           },
//         },
//         interiorCamera: {
//           type: 'interior',
//           messages: {
//             message: 'INT_DEFAULT_CAMERA',
//             identifiers: ['common_exterior'],
//           },
//         },
//         interiorCamera_1: {
//           type: 'interior',
//           messages: {
//             message: 'INT_DEFAULT_CAMERA_2',
//             identifiers: ['common_exterior'],
//           },
//         },
//         interiorCamera_2: {
//           type: 'interior',
//           messages: {},
//         },
//       },
//     },
//   },
// };
